import { ArrowBack } from "./assets/icon";
import styles from "./ReturnBackBtn.module.scss";

import { Link } from "react-router-dom";

export interface ReturnBackBtnProps {
  linnkTo?: string;
  onClick?: () => void;
  label?: string;
  variant?: "dark" | "light";
  noLabel?: boolean;
  size?: "small" | "medium" | "large";
}
export default function ReturnBackBtn({
  linnkTo,
  onClick,
  label = "Retourner",
  variant = "light",
  noLabel,
  size = "medium",
}: ReturnBackBtnProps) {

  const getSize = (size: string) : {height?: number, width?: number} => {
    switch (size) {
      case "small":
        return {height: 20, width: 20}
      case "medium":
        return {height: undefined, width: undefined}
      case "large":
        return {height: 30, width: 30}
      default:
        return {height: undefined, width: undefined}
    }}

  const {height, width} = getSize(size)
  const content = (
    <>
      {" "}
      <ArrowBack color={variant === "dark" ? "white" : undefined}height={height} width={width}/>
      {!noLabel && (
        <span
          className={[
            styles["close-btn__label"],
            styles["close-btn__label--" + variant],
            styles["close-btn__label--" + size],
          ].join(" ")}
        >
          {label}
        </span>
      )}
    </>
  );
  if (linnkTo) {
    return (
      <Link
        to={linnkTo}
        className={[styles["close-btn"], styles["close-btn--" + variant],styles["close-btn--" + size] ].join(
          " "
        )}
      >
        {content}
      </Link>
    );
  }
  return (
    <button
      className={[styles["close-btn"], styles["close-btn--" + variant], styles["close-btn--" + size] ].join(
        " "
      )}
      onClick={(e) => {
        if (onClick) {
          onClick();
        } else {
          window.history.back();
        }
      }}
    >
      {content}
    </button>
  );
}
